module.exports = __webpack_public_path__ + "img/section2Logo2.b90c1b4e.svg";